import type { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '../../template/IconTemplateIPortIcon'
import { CustomIconProps } from '../../types/types'

export const SvgHandbook = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon {...props}>
			<svg viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="Frame 277131278">
					<path
						id="Vector 47"
						d="M6.00261 -6.2653e-07L20.3359 0L20.3359 24C20.3359 27.3137 17.6496 30 14.3359 30L2.00261 30L2.00261 4C2.00261 1.79086 3.79347 -7.23094e-07 6.00261 -6.2653e-07Z"
						fill="url(#paint0_linear_18104_7455)"
					/>
					<path
						id="Vector 48"
						d="M8.66666 -5.82819e-07L22 0L22 26C22 28.2091 20.2091 30 18 30L8.66666 30L8.66666 -5.82819e-07Z"
						fill="#4A4A4A"
					/>
					<path
						id="Union"
						d="M17.8351 5C18.2951 5 18.668 5.37288 18.668 5.83286C18.668 6.29283 18.2951 6.66571 17.8351 6.66571L6.16748 6.66571C5.7075 6.66571 5.33462 6.29283 5.33462 5.83286C5.33462 5.37288 5.7075 5 6.16748 5L17.8351 5Z"
						fill="white"
					/>
					<path
						id="Union_2"
						d="M17.8351 10C18.2951 10 18.668 10.3729 18.668 10.8329C18.668 11.2928 18.2951 11.6657 17.8351 11.6657L6.16748 11.6657C5.7075 11.6657 5.33462 11.2928 5.33462 10.8329C5.33462 10.3729 5.7075 10 6.16748 10L17.8351 10Z"
						fill="white"
					/>
					<path
						id="Union_3"
						d="M12.8351 14.998C13.2951 14.998 13.668 15.3709 13.668 15.8309C13.668 16.2909 13.2951 16.6638 12.8351 16.6638L6.16753 16.6638C5.70755 16.6638 5.33467 16.2909 5.33467 15.8309C5.33467 15.3709 5.70755 14.998 6.16753 14.998L12.8351 14.998Z"
						fill="white"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear_18104_7455"
						x1="0.335937"
						y1="32.25"
						x2="0.335939"
						y2="-9.17341e-07"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#E4EDFC" />
						<stop offset="1" stopColor="#568DFE" />
					</linearGradient>
				</defs>
			</svg>
		</IconTemplateIPortIcon>
	)
}
